export default "__VITE_ASSET__BWa_eN4A__"